import actions from '~/store/modules/shared/index/actions'
import getters from '~/store/modules/shared/index/getters'
import mutations from '~/store/modules/shared/index/mutations'
import state from '~/store/modules/shared/index/state'
import { createModule } from '~/factories/store'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
